import { UserLocaleEnum } from 'collections/users';

export const getSafeLocale = (rawLocale?: string | null): UserLocaleEnum => {
  if (!rawLocale) return UserLocaleEnum.En;

  const normalized = rawLocale.toLowerCase();

  const allowedLocales = Object.values(UserLocaleEnum) as string[];

  if (allowedLocales.includes(normalized)) {
    return normalized as UserLocaleEnum;
  }

  // Fallback if backend sent an unknown / invalid value
  return UserLocaleEnum.En;
};
